import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import promoMedia from '../../../../theme/promoMedia';
import { HighlightedTile } from '../highlighted-tile/HighlightedTile';

const theme = {
    halfWidth: css`
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        ${promoMedia.desktop1440} {
            margin: -20px -16px 64px -16px;
        }
    `,
    halfWidthItem: css`
        padding-bottom: 16px;

        &:last-child {
            padding-bottom: 0;
        }

        ${promoMedia.desktop1440} {
            width: 50%;
            padding: 20px 16px;

            &:nth-last-child(2) {
                padding-bottom: 0;
            }
        }
    `,
    contentRow: css`
        ${promoMedia.desktop1440} {
            margin-bottom: 64px;
            display: grid;
            grid-template-columns: repeat(3, 1fr);
        }
    `,
    contentRowItem: css`
        padding: 0 32px;
        margin-bottom: 32px;

        &:last-child {
            margin-bottom: 0;
        }

        ${promoMedia.desktop1440} {
            margin-bottom: 0;
        }
    `,
    iconTile: css`
        margin: -16px -16px 48px -16px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        ${promoMedia.tablet744} {
            margin: -16px -16px 48px -16px;
        }

        ${promoMedia.desktop1440} {
            margin-bottom: 64px;
        }
    `,
    iconTileItem: css`
        margin-bottom: 32px;

        &:last-child {
            margin-bottom: 0;
        }

        ${promoMedia.tablet744} {
            width: 50%;
            margin-bottom: 48px;
        }

        ${promoMedia.desktop1440} {
            width: 33.33%;
        }
    `,
};

const CardsContainer = styled.div`
    margin-bottom: 32px;

    ${promoMedia.tablet744} {
        margin-bottom: 48px;
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 64px;
    }

    ${({ variant }) => variant === 'halfWidth' && theme.halfWidth};
    ${({ variant }) => variant === 'contentRow' && theme.contentRow};
    ${({ variant }) => variant === 'iconTile' && theme.iconTile};
`;

const ItemContainer = styled.div`
    width: 100%;
    box-sizing: border-box;

    ${({ variant }) => variant === 'halfWidth' && theme.halfWidthItem};
    ${({ variant }) => variant === 'contentRow' && theme.contentRowItem};
    ${({ variant }) => variant === 'iconTile' && theme.iconTileItem};
`;

export const CardsSection = (props) => {
    return (
        <CardsContainer variant={props.variant}>
            {Array.isArray(props.data) &&
                props.data
                    .filter((item) => item !== null)
                    .map((item) => {
                        return (
                            <ItemContainer key={item.id} variant={props.variant}>
                                <HighlightedTile
                                    variant={props.variant}
                                    titleGradient={props.titleGradient}
                                    bgColor={props.variant === 'halfWidth' ? 'white' : 'transparent'}
                                    icon={item.icon}
                                    title={item.title}
                                    text={item.text}
                                    promoDarkPage={props.promoDarkPage}
                                />
                            </ItemContainer>
                        );
                    })}
        </CardsContainer>
    );
};

CardsSection.propTypes = {
    variant: PropTypes.oneOf(['halfWidth', 'contentRow', 'iconTile']),
    titleGradient: PropTypes.oneOf([
        'aubergine01',
        'aubergine02',
        'aubergine03',
        'aubergine04',
        'passionFruit01',
        'passionFruit02',
        'passionFruit03',
        'oceanBlue01',
        'oceanBlue02',
        'oceanBlue03',
        'blueberryBlue01',
        'blueberryBlue02',
        'blueberryBlue03',
        'jade01',
        'jade02',
        'jade03',
    ]),
    data: PropTypes.array,
};
